<template>
	<v-card>
		<v-card-title class="mt-3">
			<h1 class="ml-2">Korespondencja</h1>
		</v-card-title>
		<v-container fluid>
			<v-btn @click="$refs.fileInput.click()" color="accent" dark>
				<v-icon color="white" left>add</v-icon>
				Dodaj załącznik
			</v-btn>
			<input v-on:change="uploadFile" ref="fileInput" id="fileInput" type="file" v-show="false"
				:accept="acceptedFiles">

			<div v-if="attachments.length === 0" class="mt-3">
				<v-alert
					:value="true"
					type="info"
					color="info"
				>Brak dodanych załączników!
				</v-alert>
			</div>

			<v-list two-line class="mt-3">
				<template v-for="(item, index) in attachments">
					<v-list-tile :key="item.id" avatar>
						<v-list-tile-avatar>
							<v-icon>description</v-icon>
						</v-list-tile-avatar>

						<v-list-tile-content>
							<v-list-tile-title v-html="item.fileName"></v-list-tile-title>
							<v-list-tile-sub-title v-html="displayDateTime(item.creationDate)"></v-list-tile-sub-title>
							<v-list-tile-action-text
								v-html="getCorrespondenceTemplateFileUrl(item.id)"></v-list-tile-action-text>
						</v-list-tile-content>

						<v-list-tile-action>
							<v-btn @click="downloadFile(item)" icon ripple>
								<v-icon color="primary">cloud_download</v-icon>
							</v-btn>
						</v-list-tile-action>

						<v-list-tile-action v-if="hasPanelEditAccess">
							<v-btn @click="deleteFile(item, index)" icon ripple>
								<v-icon color="lightred">delete</v-icon>
							</v-btn>
						</v-list-tile-action>
					</v-list-tile>
				</template>
			</v-list>
			<v-layout><h3>Uwagi</h3></v-layout>
			<v-layout>
				<v-flex>
					<v-textarea outline auto-grow v-model="project.correspondenceRemarks"
						browser-autocomplete="off" aria-label="correspondence remarks"></v-textarea>
				</v-flex>
			</v-layout>
			<v-btn primary @click="saveAgencyProjectCorrespondenceRemarks">Zapisz</v-btn>
		</v-container>
	</v-card>
</template>

<script>
	import {Files} from "../../../utils/Files";
	import {AgencyProjectCorrespondence} from "../../../api/generated/AgencyProjectCorrespondence";
	import {Api} from "../../../api";
	import {Dates} from "../../../utils/Dates";
	import {AgencyProject} from "../../../api/generated/AgencyProject";

	export default {
		name: "AgencyProjectCorrespondenceView",

		mixins: [
			Files,
			Dates
		],

		props: {
			project: {
				type: Object
			},
		},

		data () {
			return {
				attachments: [],
				isSupervisor: false,
			};
		},

		mounted () {
			this.getAttachmentList();
			this.getSupervisorStatus();
		},

		computed: {
			hasAgencyProjectPanelSupervisorModificationAccess(){
				return this.$store.state.agencyProjectPanelPermissions.hasAgencyProjectPanelSupervisorModificationAccess;
			},
			hasPanelEditAccess () {
				return this.hasAgencyProjectPanelSupervisorModificationAccess;
			}
		},

		methods: {
			async uploadFile () {
				if (this.hasIncorrectFilesExtension(this.$refs.fileInput.files)) {
					Files.methods.clearFileInput('fileInput');
          this.$messagesBus.$emit("error", "Wgrywanie plików w tym formacie jest niedozwolone. " +
              "Dozwolone formaty plików to " + this.acceptedFiles.split(",").join(", "));
          return;
				}
				let validFilesSize = await Files.methods.validateFilesSize(this, this.$refs.fileInput.files);
				if (!validFilesSize) {
					Files.methods.clearFileInput('fileInput');
					return;
				}
				Api.postMultipart(this, "/agency-project-correspondence", this.$refs.fileInput.files[0], {agencyProjectId: this.$route.params.projectId}, successResponse => {
						this.attachments.push(successResponse);
            Files.methods.clearFileInput('fileInput');
						this.$messagesBus.$emit("success", "Załącznik został dodany", successResponse);
					},
					errorResponse => {
            Files.methods.clearFileInput('fileInput');
						this.$messagesBus.$emit("error", "Nie udało się poprawnie dodać załącznika", errorResponse);
					});
			},

			downloadFile (file) {
				this.downloadAgencyProjectAttachment(this, file.id, file.fileName);
			},

			deleteFile (file, index) {
				this.$confirm("Czy na pewno chcesz usunąć załącznik?", {
					icon: 'delete',
					title: 'Usuwanie załącznika',
					color: 'lightred',
					width: 500
				})
					.then(response => {
						if (response) {
							AgencyProjectCorrespondence.delete(this, file.id,
								successResponse => {
									this.$delete(this.attachments, index);
									this.$messagesBus.$emit("success", "Załącznik został usunięty", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się poprawnie usunąć załącznika", errorResponse);
								});
						}
					});
			},

			getAttachmentList () {
				AgencyProjectCorrespondence.getList(this, this.$route.params.projectId, successResponse => {
						this.attachments = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załądować listy załączników", errorResponse);
					});
			},

			getSupervisorStatus () {
				AgencyProject.getIsSupervisor(this, this.$route.params.projectId, successResponse => {
						this.isSupervisor = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować statusu użytkownika", errorResponse);
					});
			},
			saveAgencyProjectCorrespondenceRemarks() {
				AgencyProject.putCorrespondenceRemarks(this, this.$route.params.projectId, {body: this.project.correspondenceRemarks});
			}
		}
	};
</script>

<style scoped>

</style>
